<template>
  <textarea
    rows="2"
    class="bg-white border border-dashed border-gray-300 hover:border-blue-500 h-full p-0.5"
    v-model.lazy="item.dispatch_comment"
    @change="
      $emit(
        'columnEvent',
        'autoSave',
        item,
        'dispatch_comment',
        $event.target.value
      )
    "
  />
</template>

<script>
export default {
  name: "fltl-dispatch-comment",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
